<template>
    <teleport to="body">
        <div class="modal fade"
             :class="{show: show}"
             :id="id"
             tabindex="-1"
             :aria-labelledby="id"
             aria-modal="true"
             :style="show ? 'display: block;' : ''"
             role="dialog">
            <div class="modal-dialog" :class="`modal-${size}`">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 v-if="$slots.title"
                            class="modal-title">
                            <slot name="title"></slot>
                        </h5>
                        <button type="button"
                                class="btn-close"
                                @click="$emit('close')">&times;</button>
                    </div>
                    <div class="modal-body">
                        <slot></slot>
                    </div>

                    <progress-bar v-if="enableProgress"
                                  v-bind="progress"/>

                    <div v-if="$slots.footer"
                         class="modal-footer">
                        <slot name="footer"></slot>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="show"
             class="modal-backdrop fade show"></div>
    </teleport>
</template>

<script>
import ProgressBar from "@/Components/Common/ProgressBar";
import jQuery from "jquery";
export default {
    name: "Modal",
    components: {ProgressBar},
    props: ['id', 'show', 'size', 'progress', 'enableProgress'],

    methods: {
        enableWindowScrollbar(){
            jQuery('body').css({overflow: 'auto'});
        },

        disableWindowScrollbar(){
            jQuery('body').css({overflow: 'hidden'});
        },
    },

    watch: {
        show(val){
            if( val ){
                this.disableWindowScrollbar();
            }else{
                this.enableWindowScrollbar();
            }
        }
    },

    mounted() {
        if( this.show ){
            this.disableWindowScrollbar();
        }else{
            this.enableWindowScrollbar();
        }
    },

    beforeUnmount() {
        this.enableWindowScrollbar();
    }

}
</script>

<style lang="scss" scoped>
.modal{
    overflow: auto;
}
.modal-title{
    position: relative;
}
.btn-close{
    color: $danger;
    background: rgba($light, 0.3);
    font-size: 1.6rem;
    padding: 0;
    width: auto;
    height: auto;
    border: none;
    line-height: 1;
}
</style>
